export default function printReportProducionOrder (name, id) {
  const token = localStorage.getItem("token");

  const reports = {
    simple: () => productionOrderSimple(id, token),
  }

  if (!reports[name]) {
    console.log('invalid name')
    return
  }

  reports[name]()
}

function productionOrderSimple (id, token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/production-order/reports/${id}?auth=${token}`
  );
}